function dailySeed(date = new Date()) {
    return Number(`${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`);
}

function seededRandom(seed) {
    let value = seed;
    return () => {
        value += 0x6D2B79F5;
        let result = value;
        result = Math.imul(result ^ (result >>> 15), result | 1);
        result ^= result + Math.imul(result ^ (result >>> 7), result | 61);
        return ((result ^ (result >>> 14)) >>> 0) / 4294967296;
    };
}

function initializeAuthShell(root = document) {
    for (const background of root.querySelectorAll('[data-us-auth-background]')) {
        if (background.dataset.usEnhanced === 'true') {
            continue;
        }

        background.dataset.usEnhanced = 'true';
        const minimum = Number(background.dataset.usBackgroundMin || 1);
        const maximum = Number(background.dataset.usBackgroundMax || minimum);
        const random = seededRandom(dailySeed())();
        const number = Math.floor(random * (maximum - minimum + 1)) + minimum;
        const template = background.dataset.usBackgroundTemplate;

        if (template) {
            background.style.backgroundImage = `url("${template.replace('{number}', String(number))}")`;
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAuthShell(), { once: true });
} else {
    initializeAuthShell();
}

export { dailySeed, initializeAuthShell, seededRandom };
